$(document).on("submit", "#frm-signIn-form", function (e1) {

    e1.preventDefault();

    let butt = $(document).find("button.login");
    if (butt.hasClass('disabled')) {
        return;
    }

    butt.addClass("disabled");
    butt.find(".fa-spinner").show();
    let form = $(this);

    let formData = new FormData(this);
    let formUrl = form.attr("action");

    function auth(formUrl, formData)
    {

        $.nette.ajax({
            url: formUrl,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
            off: {
                snippets: true
            },
            success: function (payload) {

                //console.log(payload);
                if (payload.error) {
                    toastr.warning(payload.error);
                }
                butt.find(".fa-spinner").hide();
                butt.removeClass('disabled');

                //window.location(payload.redirect);
            },
            error: function (err) {
                if(err.error){
                    toastr.warning(err.error);
                }
            }
        });

    }
    grecaptcha.ready(function () {
        grecaptcha.execute('6Lcwa1gfAAAAAOy4kQrA93K6nJKkbfcQt306b-kn', {action: 'login'}).then(function (token) {

            formData.append('token', token);
            formData.append('action', 'login');

            auth(formUrl, formData);

        });
    });
});